<template>
  <div class="container-bg card-care-deal" :id="cartIds()">
    <!--card care deal-->
    <span class="temp-type-card">{{ cardData.ss_type }}</span>
    <div :data-id="cardData.id" :data-nid="cardData.item_id" :data-ss-type="cardData.ss_type" class="card-title">

      <p class="picto"><i class="icon icon-hospital"><span class="sr-only">Etablissement de soins</span></i></p>

      <div class="card-title-detail">
        <h2>
          <a :data-nid="cardData.item_id"
             :href="cardData.ss_field_node_path_alias"
             @click="setOriginSearch()"
            >
            {{ cardData.tus_title }}
          </a>
        </h2>
        <p class="b-position" v-if="cardData.ss_field_categorie_organisation_label">
          {{cardData.ss_field_categorie_organisation_label}}
        </p>
        <p class="b-position" v-if="cardData.tm_X3b_und_etb_title">
          {{cardData.tm_X3b_und_etb_title[0]}}
        </p>
      </div>
    </div>
    <div class="wrapper-items-btngo">

      <ul class="wrapper-items">
        <!-- start bloc google & link map -->
        <li class="card-elm-item" v-if="cardData.tus_field_adresse1">
          <i class="icon icon-pin" aria-hidden="true"><span class="sr-only">Adresse</span></i>
          <span>
          <a :href="mapUrl"
             class="goto-card-rwd"
             @click.prevent="$emit('onMapAskFlyTo')"
             target="_blank"
             rel="noopener noreferrer"
             :aria-label="'Zoomer sur l\'adresse'  + cardData.tus_field_adresse1 + ',' + cardData.ss_field_codepostal + ',' + cardData.tm_X3b_und_field_ville" >
            {{ cardData.tus_field_adresse1 }}
          </a>

          <a href="#"
             class="goto-card"
             @click.prevent="$emit('onMapAskFlyTo')"
             :aria-details="cardData.locs_field_geolocalisation$latlon"
             :aria-label="'Zoomer sur l\'adresse'  + cardData.tus_field_adresse1 + ',' + cardData.ss_field_codepostal + ',' + cardData.tm_X3b_und_field_ville"
          >{{ cardData.tus_field_adresse1 }}</a>
          </span>

        </li>
        <!-- end bloc google & link map -->

        <!-- start bloc phone -->
        <template v-if="phone">
            <PhoneIcon :phone="phone" />
        </template>
        <!-- end bloc phone -->
      </ul>

      <!-- start button y aller -->
      <div class="btngo">
        <a class="link-external-action go-there
             tip-icon only-desctop"
           :href="mapUrl"
           target="_blank" rel="noopener noreferrer"
           :aria-label="'Aller à l\'adresse'  + cardData.tus_field_adresse1 + ',' + cardData.ss_field_codepostal + ',' + cardData.tm_X3b_und_field_ville + '(nouvelle fenêtre)'">
          <span>Y aller</span>
          <i class="icon icon-distance" aria-hidden="true"></i>
        </a>
      </div>
      <!-- end button y aller -->
    </div>
  </div>
</template>

<script>

import { computed } from 'vue';
import { setOriginSearch } from '@/helpers';
import FavouriteCardHook from '@/hooks/favouriteCard.hook';
import useOnRowIsDisabled from '@/composables/useOnRowIsDisabled';

import PhoneIcon from '@/components/legacy/searchFind/cardType/PhoneIcon.component.vue';
import DrupalSettings from '@/services/legacy/api/DrupalSettings/searchFind';

export default {
  name: 'CardCareDealComponent',
  components: {
    PhoneIcon,
  },
  props: {
    cardData: { type: Object, default: null },
    isConnected: { type: Boolean, default: false },
    listResFav: { type: Array, default: () => ([]) },
    mapUrl: { type: String, default: '' },
  },
  emits: ['onMapAskFlyTo'],
  data() {
    return {
      longLat: this.cardData.locs_field_geolocalisation$latlon,
      wording: {
        labels: DrupalSettings.questionnaire.labels,
        languages: DrupalSettings.questionnaire.languages,
      },
    };
  },
  setup(props, { emit }) {
    const phone = computed(() => {
      if (props.cardData.tm_X3b_und_field_phone_number) {
        return props.cardData.tm_X3b_und_field_phone_number[0];
      }
      if (props.cardData.tm_field_telephone_fixe) {
        return props.cardData.tm_field_telephone_fixe[0];
      }
      return null;
    });

    function cartIds() {
      const cartId = props.cardData.item_id;
      return `card-node-${cartId}`;
    }
    const {
      favorisClass, favorisClick, favorisIsIn, isFavBtnClicked, isActiveCard, favorisStarClass,
    } = FavouriteCardHook(props, emit);
    const { onRowIsDisabled } = useOnRowIsDisabled();

    return {
      setOriginSearch,
      isFavBtnClicked,
      isActiveCard,
      favorisIsIn,
      cartIds,
      favorisClass,
      favorisStarClass,
      favorisClick,
      phone,
      onRowIsDisabled,
    };
  },
};
</script>
